import React from "react";
import useSWR from "swr";
import { fetcher, fmtN } from "./common";
import { Stat } from "@/components/app/PageHeader";

function MiniBars({ series }) {
  if (!series?.length) return <div className="text-xs text-zinc-500 py-8 text-center">Aucun mouvement de trésorerie.</div>;
  const max = Math.max(...series.map((s) => Math.abs(s.solde)), 1);
  return (
    <div className="flex items-end gap-3 h-32">
      {series.map((s) => (
        <div key={s.month} className="flex-1 flex flex-col items-center gap-1">
          <div className="text-[10px] text-zinc-500">{fmtN(s.solde)}</div>
          <div
            className={`w-full rounded-t ${s.solde >= 0 ? "bg-[#2E3192]" : "bg-red-800"}`}
            style={{ height: `${Math.max(4, (Math.abs(s.solde) / max) * 80)}px` }}
          ></div>
          <div className="text-[10px] text-zinc-400">{s.month}</div>
        </div>
      ))}
    </div>
  );
}

export default function DossierDashboard({ file }) {
  const { data } = useSWR(`/accounting/files/${file.id}/overview`, fetcher);
  if (!data) return <div className="text-sm text-zinc-500">Chargement…</div>;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat testid="dash-tresorerie" label="Trésorerie" value={`${fmtN(data.tresorerie)} ${data.currency}`} />
        <Stat testid="dash-resultat" label="Résultat de l'exercice" value={`${fmtN(data.resultat)} ${data.currency}`} hint={`Produits ${fmtN(data.produits)} — Charges ${fmtN(data.charges)}`} />
        <Stat testid="dash-clients" label="Encours clients" value={`${fmtN(data.encours_clients)} ${data.currency}`} />
        <Stat testid="dash-fournisseurs" label="Dettes fournisseurs" value={`${fmtN(data.dettes_fournisseurs)} ${data.currency}`} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 border border-zinc-200 bg-white rounded-md p-6">
          <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mb-4">Trésorerie mensuelle (écritures validées)</div>
          <MiniBars series={data.treso_mensuelle} />
        </div>
        <div className="border border-zinc-200 bg-white rounded-md p-6">
          <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 mb-4">À traiter</div>
          {data.brouillards > 0 ? (
            <div className="flex items-center gap-3">
              <span className="font-serif-display text-4xl">{data.brouillards}</span>
              <span className="text-sm text-zinc-600">écriture(s) en brouillard à imputer/valider (onglet Comptabilité → Saisie)</span>
            </div>
          ) : (
            <div className="text-sm text-emerald-800 bg-emerald-50 rounded px-3 py-2">Aucune écriture en brouillard.</div>
          )}
        </div>
      </div>
    </div>
  );
}
